export default __webpack_public_path__ + "static/media/2399.fe3e4234.png";